// ----------------------------------------------------------------------
// <copyright file="Izenda.TextHighlight.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Text high light Component
 * Example :
 * <TextHighLight className="pull-left" onClick={this.clickEdit} highlight={dataSource.searchText} text={dataSource.name}></TextHighLight>
 */
!(function() {
  var React = require('react');
  const { escape, escapeRegExp } = require('lodash/fp');

  var TextHighLight = React.createClass({
    propTypes: {
      className: React.PropTypes.string,
      onClick: React.PropTypes.func,
      highlight: React.PropTypes.string,
      text: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
      markTag: React.PropTypes.string,
      caseSensitive: React.PropTypes.bool,
      tooltip: React.PropTypes.string,
      notHighlight: React.PropTypes.bool
    },

    /**
     * initial properties
     * @returns {Object}
     */
    getDefaultProps: function() {
      return {
        highlight: null,
        text: null,
        markTag: 'mark',
        caseSensitive: false,
        className: '',
        tooltip: ''
      };
    },

    /**
     * generate inner html
     */
    createMarkup: function() {
      return this.props.notHighlight
        ? {
            __html: escape(this.props.text)
          }
        : {
            __html: this.mark(this.props.highlight, this.props.text, this.props.markTag, this.props.caseSensitive)
          };
    },

    /**
     * Mark search text
     */
    mark: function(val, str, markTag, caseSensitive) {
      val = val || '';

      str = escape(str);

      var escapeReg = escapeRegExp(escape(val));
      var tagStr = '<{tag}>$&</{tag}>'.replace(/{tag}/gi, markTag);

      markTag = markTag || 'mark';

      if (val.length === 0) {
        return str;
      }

      var regex = RegExp(escapeReg, caseSensitive ? 'g' : 'gi');

      return str.replace(regex, tagStr);
    },

    /**
     * render component
     * @returns {Object}
     */
    render: function() {
      return (
        <span
          className={this.props.className}
          onClick={this.props.onClick}
          dangerouslySetInnerHTML={this.createMarkup()}
          title={this.props.tooltip}
        />
      );
    }
  });

  module.exports = TextHighLight;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.TextHighLight.jsx